<div class="theme-picker">
  <p class="theme-picker__hint">
    테마를 눌러 선택하거나 해제하세요. 전부 해제한 상태로도 저장할 수 있어요.
    <span class="theme-picker__hint-sub">칩에 마우스를 올리면 판정 기준이 보여요.</span>
  </p>

  <p class="theme-picker__empty" *ngIf="loadFailed">테마 목록을 불러오지 못했어요.</p>

  <div class="theme-picker__section" *ngFor="let section of sections">
    <!-- header/section 대신 div 를 쓴다 — 시맨틱 태그는 전역 스타일과 충돌해 그룹명이 렌더링되지 않는다. -->
    <div class="theme-picker__head">
      <span class="theme-picker__group">{{ section.group.name }}</span>
      <!-- 상한이 없는 그룹은 분모 없이 고른 개수만 보여준다 -->
      <span class="theme-picker__count" [class.is-full]="isGroupAtCap(section)">
        {{ selectedCountIn(section) }}<ng-container *ngIf="section.group.maxSelectable !== null">
          / {{ section.group.maxSelectable }}</ng-container
        >
      </span>
    </div>

    <div class="theme-picker__chips">
      <button
        type="button"
        class="theme-picker__chip"
        *ngFor="let theme of section.themes"
        [class.is-selected]="isSelected(theme)"
        [disabled]="isChipDisabled(section, theme)"
        [attr.aria-pressed]="isSelected(theme)"
        [title]="theme.guide || ''"
        (click)="toggle(section, theme)"
      >
        <span class="theme-picker__emoji" *ngIf="theme.emoji">{{ theme.emoji }}</span>{{ theme.name }}
      </button>
    </div>
  </div>
</div>
